import React from 'react';
import adaniLogo from '../../Adani_2012_logo.png';

export default function LandingPage({ onSignIn }) {
  return (
    <div className="pip-root" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Top bar */}
      <header style={{ padding: '20px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 2 }}>
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: 'var(--adani-gradient)' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
          </div>
          <span className="font-google text-[16px] font-semibold text-[var(--adani-text-primary)] tracking-tight">PIP</span>
        </div>
        <img src={adaniLogo} alt="Adani" style={{ height: 32, objectFit: 'contain' }} />
      </header>

      {/* Hero */}
      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 40px', position: 'relative' }}>
        {/* Decorative gradient orbs */}
        <div style={{
          position: 'absolute', top: '10%', left: '8%', width: 320, height: 320,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(0,163,224,0.15) 0%, transparent 70%)',
          filter: 'blur(40px)', pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', bottom: '10%', right: '10%', width: 360, height: 360,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(212,39,137,0.12) 0%, transparent 70%)',
          filter: 'blur(40px)', pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', top: '40%', right: '30%', width: 240, height: 240,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(108,59,191,0.1) 0%, transparent 70%)',
          filter: 'blur(40px)', pointerEvents: 'none',
        }} />

        <div className="animate-slide-up" style={{ textAlign: 'center', maxWidth: 1100, position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '6px 16px', borderRadius: 999,
            background: 'rgba(255,255,255,0.6)', border: '1px solid rgba(255,255,255,0.5)',
            backdropFilter: 'blur(12px)', marginBottom: 28,
            fontSize: 13, fontWeight: 500, color: 'var(--adani-text-secondary)',
          }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--adani-success)' }} />
            AI-Powered Intelligence Platform
          </div>

          <h1 className="font-google" style={{
            fontSize: 48, fontWeight: 700, lineHeight: 1.15, letterSpacing: '-0.02em',
            color: 'var(--adani-text-primary)', marginBottom: 8,
          }}>
            Digital Command Center
          </h1>
          <p className="font-google" style={{
            fontSize: 28, fontWeight: 600, lineHeight: 1.3, marginBottom: 24,
            background: 'var(--adani-gradient)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>
            Built for Adani Defence
          </p>

          <p style={{
            fontSize: 17, lineHeight: 1.65, color: 'var(--adani-text-secondary)',
            maxWidth: 540, margin: '0 auto 36px',
          }}>
            AI powered productivity and sales intelligence platform to transform sales leads into actionable intelligence for faster decision making
          </p>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14 }}>
            <button onClick={onSignIn} className="btn-primary" style={{ padding: '14px 36px', fontSize: 15, fontWeight: 600, borderRadius: 12 }}>
              Sign In
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
            </button>
          </div>

          <div style={{ marginTop: 48, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 18, width: '100vw', maxWidth: 1100, padding: '0 40px', boxSizing: 'border-box' }}>
            {[
              {
                title: 'Smart Leads Management',
                desc: 'Capture, qualify and track leads through an intelligent AI-driven pipeline',
                icon: <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
                gradient: 'linear-gradient(135deg, #00A3E0 0%, #2E6DE5 100%)',
              },
              {
                title: 'Document AI',
                desc: 'Extract leads from PDFs, images and scanned documents automatically',
                icon: <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
                gradient: 'linear-gradient(135deg, #2E6DE5 0%, #6C3BBF 100%)',
              },
              {
                title: 'Smart Agent',
                desc: 'AI-powered voice calls that capture and qualify leads for you',
                icon: <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>,
                gradient: 'linear-gradient(135deg, #6C3BBF 0%, #B7279C 100%)',
              },
              {
                title: 'Analytics',
                desc: 'Real-time dashboards and insights to drive data-backed decisions',
                icon: <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
                gradient: 'linear-gradient(135deg, #B7279C 0%, #D42789 100%)',
              },
            ].map(({ title, desc, icon, gradient }) => (
              <div key={title} style={{
                background: gradient,
                padding: '24px', borderRadius: 20, textAlign: 'center',
                aspectRatio: '1 / 1',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12,
                boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                border: '1px solid rgba(255,255,255,0.15)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.15)'; }}
              >
                <div style={{ opacity: 0.9 }}>{icon}</div>
                <div>
                  <p style={{ fontSize: 17, fontWeight: 700, color: '#fff', marginBottom: 6 }}>{title}</p>
                  <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', lineHeight: 1.5 }}>{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={{ padding: '16px 40px', textAlign: 'center', position: 'relative', zIndex: 2 }}>
        <p style={{ fontSize: 11, color: 'var(--adani-text-tertiary)' }}>Adani Group · Programme Intelligence Platform</p>
      </footer>
    </div>
  );
}
